import {
    CHeading2,
    CHeading3,
    CSpan,
    CFormGroup,
    CParagraph,
    CLabel,
    CLink,
    CSmall,
    CHeading4,
    CTable,
    CPrimaryTitle,
    CSecondaryTitle
} from './styled'

export default {
    'c-heading-2': CHeading2,
    'c-heading-3': CHeading3,
    'c-heading-4': CHeading4,
    'c-span': CSpan,
    'c-form-group': CFormGroup,
    'c-paragraph': CParagraph,
    'c-label': CLabel,
    'c-link': CLink,
    'c-small': CSmall,
    'c-table': CTable,
    'primary-title': CPrimaryTitle,
    'secondary-title': CSecondaryTitle
}